import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { DecisionModelWorkflow } from '@core/model/DecisionModelWorkflow';

import { getHttpHeaders } from '@commons/utility/util';

@Injectable({
  providedIn: 'root',
})
export class DisbursementAccountSelectionService {
  private bankAccountsMessageSource = new BehaviorSubject([]);
  accountsMessage$ = this.bankAccountsMessageSource.asObservable();

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public executeDecisionModel(decisionModelWorkflow: DecisionModelWorkflow, url: string): Observable<any> {
    return this.http.post(url, decisionModelWorkflow, {
      headers: this.headers,
    });
  }

  changeMessage(accounts: any) {
    this.bankAccountsMessageSource.next(accounts);
  }
}
